<dashboard-dialog-frame class="goal-details-dialog" [header]="header()" [actions]="actions()" [dialogRef]="dialogRef">
	<kendo-tabstrip class="h-100 px-2 pt-2">

		<kendo-tabstrip-tab title="Details" [selected]="true">
			<ng-template kendoTabContent>
				<goal-details-part></goal-details-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Comments">
			<ng-template kendoTabContent>
				<goal-comments-part [dialogBodyHeight]="dialogContext.dimensions().bodyHeight"></goal-comments-part>
			</ng-template>
		</kendo-tabstrip-tab>

	</kendo-tabstrip>
</dashboard-dialog-frame>